import { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { usePopper } from 'react-popper'

import colors from 'components/utils/colors'

import IconLink from 'components/Shared/IconLink/Index'
import LoadingIndicator from 'components/Shared/LoadingIndicator/Index'

const ImagePreviewIcon = styled(IconLink)`
  padding-right: 8px;
`

const ImageWrapper = styled.div`
  z-index: 2000; /* make it overlap sidebar and main menu */
  border: 1px solid #DEDEDE;
  box-shadow: 4px 4px 5px 0px #66666680;
  background: #CCCCCC;
  min-width: 80px;
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
`

// Make it a block element. Images are inline elements by default
// amd have leading showing 2 extra pixels in the bottom
const Image = styled.img`
  display: block;
`

const ImagePreview = ({ imagePreviewUrl }) => {
  const [referenceElement, setReferenceElement] = useState(null)
  const [popperElement, setPopperElement] = useState(null)
  const { styles, attributes, forceUpdate } = usePopper(referenceElement, popperElement, {
    placement: 'right-end',
    strategy: 'fixed',
    modifiers: [
      {
        name: 'flip',
        options: {
          fallbackPlacements: ['left-end', 'right', 'left'],
        },
      },
      {
        name: 'offset',
        options: {
          offset: [-24, 0],
        },
      },
    ],
  })

  const [isPreviewVisible, setIsPreviewVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  const onPreviewIconMouseEnter = () => {
    setIsPreviewVisible(true)
    setIsLoading(true)
  }

  const onPreviewIconMouseLeave = () => {
    setIsPreviewVisible(false)
    setIsLoading(false)
  }

  const onImageLoaded = () => {
    setIsLoading(false)
    forceUpdate()
  }

  if (!imagePreviewUrl) {
    return null
  }

  return (
    <>
      <span ref={setReferenceElement}>
        <ImagePreviewIcon
          iconName='icon-image'
          onMouseEnter={onPreviewIconMouseEnter}
          onMouseLeave={onPreviewIconMouseLeave}
          color={colors.secondary70}
        />
      </span>

      {isPreviewVisible && (
        <ImageWrapper
          ref={setPopperElement}
          style={styles.popper}
          {...attributes.popper}
          data-test='image-preview'
        >
          <LoadingIndicator loading={isLoading} tiny />
          <Image
            src={imagePreviewUrl}
            onLoad={onImageLoaded}
          />
        </ImageWrapper>
      )}
    </>
  )
}

ImagePreview.propTypes = {
  imagePreviewUrl: PropTypes.string,
}

export default ImagePreview
